import Empty from 'constants/empty';

const gladChatSelector = store => store.gladChat || Empty.Object;

export { gladChatSelector };
